import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
import { milestones } from '../../data/record';
export function First100Days() {
  return <section aria-labelledby="hundred-heading" className="bg-green-800 py-16 text-white sm:py-20 lg:py-28" data-id="element-149" data-mp="1eizajmh2ytyh">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-150" data-mp="1t72jn4qf6lri">
        <SectionHeading eyebrow="Before anything else" title="The first 100 days" intro="A clear, dated view of what this administration does before it asks to be judged on anything else." onDark action={<Button variant="secondary" onDark data-id="element-152" data-mp="1y7ggrrqhgbar">
              Explore the first 100 days
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-153" data-mp="7vaksfsii9qk" />
            </Button>} data-id="element-151" data-mp="1o8r9su04kb9a" />

        <ol className="mt-14 grid gap-8 lg:grid-cols-4 lg:gap-6" data-id="element-154" data-mp="3uqn9b41143w">
          {milestones.map((milestone, index) => <Reveal key={milestone.marker} delay={index * 0.05} data-id="element-155" data-mp="16qt4szw08812" data-mpi={index}>
              <li className="relative h-full border-t-2 border-gold-500/60 pt-6" data-id="element-156" data-mp="1bsifgefbejom">
                <span className="absolute -top-[7px] left-0 h-3 w-3 rounded-full bg-gold-400" data-id="element-157" data-mp="1gpsfsp48sfr8" />
                <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-gold-300" data-id="element-158" data-mp="1lhts2b1eu6h9">
                  {milestone.marker}
                </p>
                <h3 className="mt-2 font-display text-[22px] leading-snug text-white" data-id="element-159" data-mp="1qizhnzzrxdmk">
                  {milestone.title}
                </h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-white/65" data-id="element-160" data-mp="1zh1nqtyd6wgp">
                  {milestone.description}
                </p>
                <ul className="mt-5 space-y-2.5" data-id="element-161" data-mp="24ebo34naksjb">
                  {milestone.priorities.map(priority => <li key={priority} className="flex gap-2.5 text-[14px] text-white/85" data-id="element-162" data-mp="55n0qkwqnb4n">
                      <CheckIcon aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" data-id="element-163" data-mp="a4hj5lqsmxo8" />
                      {priority}
                    </li>)}
                </ul>
              </li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}